import { useMemo } from 'react'
import { useLocation } from 'react-router-dom'

export const queryFlagFromSearch = (search: string, name: string): boolean => {
    const value = new URLSearchParams(search).get(name)
    return value === '1' || value === 'true'
}

export const useQueryFlag = (name: string): boolean => {
    const { search } = useLocation()
    return useMemo(() => queryFlagFromSearch(search, name), [search, name])
}
